import type { Course, AppSettings } from '@gpa-scales/shared-types';
import { AGSubject } from '@gpa-scales/shared-types';
import { calculateAllGPA } from './gpaCalculations';

export interface SubjectGPA {
  subject: AGSubject;
  gpa: number;
  weightedGpa: number;
  courseCount: number;
  totalCredits: number;
}

export function computeSubjectBreakdown(
  courses: Course[],
  settings: AppSettings
): SubjectGPA[] {
  const subjects = [AGSubject.A, AGSubject.B, AGSubject.C, AGSubject.D, AGSubject.E, AGSubject.F, AGSubject.G];

  return subjects.map((subject) => {
    const subjectCourses = courses.filter((c) => c.agSubject === subject);

    if (subjectCourses.length === 0) {
      return {
        subject,
        gpa: 0,
        weightedGpa: 0,
        courseCount: 0,
        totalCredits: 0,
      };
    }

    const variants = calculateAllGPA(subjectCourses, settings);
    const unweighted = variants.find((v) => v.label === 'Unweighted GPA');
    const commonApp = variants.find((v) => v.label === 'Common App Weighted GPA');

    return {
      subject,
      gpa: unweighted?.value ?? 0,
      weightedGpa: commonApp?.value ?? 0,
      courseCount: subjectCourses.length,
      totalCredits: subjectCourses.reduce((sum, c) => sum + c.credits, 0),
    };
  });
}
